import request from '@/utils/request'

// 买家列表
export const buyer_list=(data)=>{
  return request({
    url: '/erp/base-buyer/index',
    method: 'get',
    data
  })
}

// 买家新增 
export const buyer_create=(data)=>{
  return request({
    url: '/erp/base-buyer/edit__role',
    method: 'post',
    data
  })
}

// 买家新增 || 编辑
export const buyer_update=(data)=>{
  return request({
    url: '/erp/base-buyer/edit',
    method: 'post',
    data
  })
}

// 买家详情--业务信息
export const buyer_detail_base=(data)=>{
  return request({
    url: '/erp/base-buyer/info',
    method: 'get',
    data
  })
}

// 买家详情--采购详情
export const buyer_detail_order=(data)=>{
  return request({
    url: '/erp/base-buyer/order-detail',
    method: 'get',
    data
  })
}

// 买家详情--还款详情
export const buyer_detail_repayment=(data)=>{
  return request({
    url: '/erp/base-buyer/repayment-detail',
    method: 'get',
    data
  })
}

// 买家详情--历史订单
export const buyer_history_repayment=(data)=>{
  return request({
    url: '/erp/base-buyer/history-debt',
    method: 'get',
    data
  })
}
//买家详情--商品统计
export const buyer_goods_acount=(data)=>{
  return request({
    url:'/erp/base-buyer/goods-count',
    method: 'post',
    data
  })
}